import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import StatsStrip from "@/components/site/StatsStrip";
import Services from "@/components/site/Services";
import Industries from "@/components/site/Industries";
import Process from "@/components/site/Process";
import WhyUs from "@/components/site/WhyUs";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";
import SEO from "@/components/SEO";

export default function Landing() {
  return (
    <main className="relative min-h-screen bg-[#0B0A0C] text-[#F4EADE]" data-testid="landing-page">
      <SEO
        title="B2B Software Development & Global Brokerage Services"
        description="Custom B2B software, e-commerce platforms, integrations and global brokerage — launch-ready solutions for international commerce. You ask, we develop."
        path="/classic"
      />
      <Header />
      <Hero />
      <StatsStrip />
      <Services />
      <Industries />
      <Process />
      <WhyUs />
      <Contact />
      <Footer />
    </main>
  );
}
